import { m } from 'framer-motion';
import { Link as RouterLink } from 'react-router-dom';
import { Button, Stack, Typography } from '@mui/material';
import MotionContainer from '#/components/shared/animate/MotionContainer';
import { varBounce } from '#/components/shared/animate/variants';
import Page from '#/components/shared/ui/Page';
import Image from '#/components/shared/ui/Image';

export default function Page500() {
  return (
    <Stack
      sx={{
        py: 12,
        maxWidth: 400,
        textAlign: 'center',
        m: 'auto',
        minHeight: '100vh',
        justifyContent: 'center',
      }}
    >
      <Page title="500">
        <MotionContainer>
          <m.div variants={varBounce().in}>
            <Typography variant="h3" paragraph>
              500 Internal Server Error
            </Typography>
          </m.div>

          <m.div variants={varBounce().in}>
            <Typography sx={{ color: 'text.secondary' }}>
              There was an error, please try again later.
            </Typography>
          </m.div>

          <m.div variants={varBounce().in}>
            <Image
              sx={{ my: { xs: 5, sm: 10 } }}
              src="/assets/icons/500.svg"
              alt="500"
            />
          </m.div>

          <Button
            component={RouterLink}
            to="/"
            size="large"
            variant="contained"
          >
            Go to Home
          </Button>
        </MotionContainer>
      </Page>
    </Stack>
  );
}
